import NiceModal, { useModal } from '@ebay/nice-modal-react';
import Drawer from '@/components/Modals/Drawer';
import { IAgent } from '@/types';
import AgentForm from './AgentForm';

interface AgentDrawerProps {
  agent: IAgent;
}

const AgentDrawer = NiceModal.create(({ agent }: AgentDrawerProps) => {
  const modal = useModal('agent-drawer');

  return (
    <Drawer modal={modal} title="Call Scenarios">
      <AgentForm agent={agent} onClose={() => modal.hide()} />
    </Drawer>
  );
});

export default AgentDrawer;
